/**
 * @desc 根据子仓编号获取母仓信息
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.warehouseFacadeImpl.getRootWarehouse.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/warehouse/getRootWarehouse`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
